export class PensionSavings {
    fundValue: number;
    tfcAmt: string;
    tfcPct: string;
    extTfcAmt: string;
    extTfcPct: string;
    fullFundInd: string;
    drawdownInd: string;
    pensionProvider: string;
    address: {
        line1: string,
        line2: string,
        line3: string,
        line4: string,
        postcode: string,
        countryCode: string
    };
    policyNo: string;
    isCeding: boolean;
    taxfreeSelected: string;
    optionCode: number;
    providerReference: number;
    productCode?: string;
}
